import { Component, OnInit } from '@angular/core';
import { PRODUCTS } from '../../../helpers/constants';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsComponent implements OnInit {
  products: string[];

  constructor() {
    this.products = [
      PRODUCTS.RAAMSTICKERS,
      PRODUCTS.PROJECTBORDEN,
      PRODUCTS.PRINT_PRODUCTION,
    ];
  }

  ngOnInit() {}
}
